<template>
  <div :style="{'width': imgWidth, 'top': top, 'left': left, 'right': right, 'bottom': bottom}"
       class="gift img-w">
    <svg viewBox="0 0 133 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M132.633 0.136597H0.376465V56.1366H132.633V0.136597Z" fill="url(#paint0_linear_2_308)"/>
      <path d="M65.6951 0.136475L63.5732 0.136475V56.1365H65.6951V0.136475Z" fill="black"/>
      <path d="M132.633 27.0424L0.376465 27.0424L0.376465 29.2299L132.633 29.2299V27.0424Z" fill="black"/>
      <path d="M73.3295 20.9832L71.7982 19.4301L64.6232 26.6051L57.4701 19.4301L55.917 20.9832L63.092 28.1363L55.917 35.2894L57.4701 36.8426L64.6232 29.6894L71.7982 36.8426L73.3295 35.2894L66.1764 28.1363L73.3295 20.9832Z" fill="black"/>
      <defs>
        <linearGradient id="paint0_linear_2_308" x1="129.825" y1="1.32914" x2="91.3286" y2="92.2582" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFD939"/>
          <stop offset="0.06" stop-color="#FFD33B"/>
          <stop offset="0.38" stop-color="#FFB145"/>
          <stop offset="0.65" stop-color="#FF9C4B"/>
          <stop offset="0.83" stop-color="#FF954D"/>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
  export default {
    name: "Gift4",
    props: {
      imgWidth: {
        default: '7rem'
      },
      top: {
        default: 'auto'
      },
      left: {
        default: 'auto'
      },
      right: {
        default: 'auto'
      },
      bottom: {
        default: 'auto'
      },
      color: {
        default: 'white'
      }
    },
  }
</script>

<style scoped lang="scss">
  .gift {
    position: absolute;
    z-index: 50;

    &.is-yellow {
      svg * {
        fill: $yellow;
      }
    }
    &.is-white {
      svg * {
        fill: white;
      }
    }
  }
</style>
